import { hotjar } from "react-hotjar";
import { envConfig } from "../api/endpoints";

export function initialise() {
  if (envConfig["hotjarEnabled"]) {
    hotjar.initialize(1812296, 6);
  }
}
